import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { OneLoadedState } from '../store/appStatusState';

export function oneLoadedReducer(state: OneLoadedState = {}, action: AllActions): OneLoadedState {
  switch (action.type) {
    case InternalActionTypes.EventLoaded:
      return {
        ...state,
        [action.eventId]: true,
      };
    default:
      return state;
  }
}
